declare global {
  interface Window {
    env: any;
  }
}

export const env: {
  PUBLIC_URL: string;
  REACT_APP_V1_URL: string;
  REACT_APP_V1_URL_LOCAL: string;
  REACT_APP_API_URL: string;
  REACT_APP_TERMS_URL: string;
  REACT_APP_PRIVACY_POLICY_URL: string;
  REACT_APP_TOLGEE_API_URL: string;
  REACT_APP_TOLGEE_API_KEY: string;
  REACT_APP_DICTIONARIES_REGISTRY_COURTS_URL: string;
  REACT_APP_DICTIONARIES_TAX_OFFICES_URL: string;
  REACT_APP_DICTIONARIES_SIGNIUS_LANGUAGES_URL: string;
  REACT_APP_DICTIONARIES_SIGNIUS_COUNTRIES_URL: string;

  REACT_APP_SIGNIUS_PRIVACY_POLICY_URL: string;
  REACT_APP_SIGNIUS_FAQ_URL: string;
  REACT_APP_SIGNIUS_TERMS_URL: string;
  REACT_APP_EUROCERT_TERMS_URL: string;

  REACT_APP_NEWS_URL: string;
  REACT_APP_SUPPORT_MAIL: string;
  REACT_APP_BUILD_HASH?: string;
} = { ...import.meta.env, ...window.env };
